import { useEffect } from 'react';

/** Warns the admin before they navigate away while a batch run is in progress. */
export const useBeforeUnloadWarning = (isActive: boolean) => {
  useEffect(() => {
    if (!isActive) {
      return;
    }

    const onBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      // Chrome requires `returnValue` to be set to show the confirmation dialog.
      event.returnValue = '';
    };

    window.addEventListener('beforeunload', onBeforeUnload);
    return () => window.removeEventListener('beforeunload', onBeforeUnload);
  }, [isActive]);
};

export default useBeforeUnloadWarning;
